import React from 'react';
import { WebinarPage } from './pages/WebinarPage';
export function App() {
  return <WebinarPage data-id="element-0" />;
}